'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @module trimClassName
 *
 * @description
 *
 * Removes unnecessary whitespaces from a class name string
 *
 * @example
 *
 * import trimClassName from 'dumb-bem/lib/trim-class-name'
 *
 * trimClassName(' header  header--landing ')
 *   // => 'header header--landing'
 *
 */
exports.default = function (className) {
  return className.trim().replace(/\s\s+/g, ' ');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/dumb-bem/lib/trim-class-name.js
// module id = 1174
// module chunks = 0